interface Action {
  type: string;
  payload: string;
}

const menuReducer = (state = { activeLink: "Home" }, action: Action) => {
  switch (action.type) {
    case "SET_ACTIVE_LINK":
      return { ...state, activeLink: action.payload };
    default:
      return state;
  }
};

export default menuReducer;
